import type { ButtonProps } from "@ntemarked/mittne-components/dist/Button/Button";
import MittneButton from "@ntemarked/mittne-components/dist/Button/Button";

import { useForm } from "components/organisms/form/Form";

export default function FormButton({ loading: rootLoading, ...props }: ButtonProps) {
	const { loading, disabled } = useForm();
	const isLoading = loading || rootLoading;
	return <MittneButton submit {...props} loading={isLoading} disabled={disabled || isLoading || props.disabled} />;
}
